import Component from './component'
import PopupMessage from './popupMessage'
import { relaxImage } from './watermark'

module.exports = {
  Component,
  PopupMessage,
  relaxImage
}
